<template>
    <section class="all-v">
        <div class="auth-form">
            <h1 :style="theme.header" v-if="!confirmView">Sign In</h1>
            <h1 :style="theme.header" v-if="confirmView">Confirm Sign In</h1>
            <div v-if="!confirmView">
                <div>
                    <label for="username" class="label-mini">Username/Email address</label>
                    <input class="form-control w-input" v-model.trim="username" id="username" name="wg-username" type="text" placeholder="Username/Email address" autofocus @keyup.enter="signIn"/>
                </div>
                <div>
                    <label for="password" class="label-mini">Password</label>
                    <input class="form-control w-input" v-model="password" id="password" name="wg-password" :type="showPass ? '' : 'password'" placeholder="Password" @keyup.enter="signIn"/>
                </div>
                <div class="cursor-pointer text-left mt-3" @click="showPass = !showPass">
                    <span v-if="!showPass"><i class="fa fa-eye"></i> Show</span>
                    <span v-if="showPass"><i class="fa fa-eye-slash"></i> Hide</span>
                </div>
                <div :style="theme.actionRowSignin">
                    <w-button :inverse="true" id="signin-btn" class="px-4" @click="signIn" :disabled="!username || !password">Sign In</w-button>
                </div>
            </div>
            <div v-if="confirmView">
                <div>
                    <label for="code" class="label-mini">Code</label>
                    <input class="form-control w-input" v-model="code" placeholder="Code" id="code" @keyup.enter="confirm"/>
                </div>
                <div :style="theme.actionRow">
                    <w-button :inverse="true" class="px-4" @click="confirm" :disabled="!code">Confirm</w-button>
                </div>
            </div>
            <div :style="theme.footer" class="auth-form-footer">
                <span>
                    <router-link to="/auth/forgotPassword" id="forgot-btn">Forgot Password</router-link>
                </span>&nbsp;
                <span>
                    <router-link to="/auth/signUp" id="signup-btn">Sign Up</router-link>
                </span>
            </div>
            <div class="alert alert-danger mt-4" v-if="error">{{error}}</div>
        </div>
        <w-version/>
    </section>

</template>

<script>
import { Logger, JS } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import AmplifyTheme from '../../style/AmplifyTheme'

const logger = new Logger('SignInComp')

export default {
    name: 'SignIn',
    data () {
        return {
            username: '',
            password: '',

            user: null,
            attributes: null,
            confirmView: false,
            showPass: false,
            code: '',

            error: '',
            theme: AmplifyTheme
        }
    },
    methods: {
        signIn () {
            Auth.signIn(this.username.toLowerCase().trim(), this.password).then(user => {
                this.user = user
                this.$store.dispatch('auth/fetchUser')
                if (user.challengeName === 'SMS_MFA') {
                    this.confirmView = true
                    return
                }
                this.checkUser()
            }).catch(err => this.setError(err))
        },
        checkUser () {
            const user = this.user
            if (!user) {
                return
            }

            Auth.verifiedContact(user).then(data => {
                logger.debug('verify result', data)
                this.$store.commit('auth/setUserVerification', data)
                if (!JS.isEmpty(data.verified)) {
                    if (this.$route.query.redirect) {
                        location.href = this.$route.query.redirect
                    } else if (this.$store.getters['auth/signUpRedirectPath']) {
                        location.href = this.$store.getters['auth/signUpRedirectPath']
                        this.$store.dispatch('auth/setSignUpRedirectPath', '')
                    } else if (this.$store.getters['auth/redirectPath']) {
                        this.$router.push(this.$store.getters['auth/redirectPath'])
                        this.$store.dispatch('auth/setRedirectPath', '')
                    } else {
                        this.$router.push('/').catch(err => err)
                    }
                } else {
                    this.$router.push('/auth/verifyContact')
                }
            }).catch(e => e)
        },
        confirm () {
            Auth.confirmSignIn(this.user, this.code).then(() => {
                this.$router.push('/').catch(err => err)
            }).catch(err => this.setError(err))
        },
        forgot () {
            this.$router.push('/auth/forgotPassword')
        },
        signUp () {
            this.$router.push('/auth/signUp')
        },
        setError (err) {
            this.error = err ? err.message || err : ''
        }
    }
}
</script>

<style scoped>
    h1 {
        font-size: 28px !important;
        font-weight: 500 !important;
        color: #1a3f65 !important;
    }

    .auth-form {
        display: inline-block;
        width: 320px;
        margin-top: 85px;
        padding-top: 15px;
    }

    .auth-form-footer {
        display: flex;
        margin-top: 1em;
        justify-content: space-between;
    }

    .auth-form-footer a {
        color: #23B8DC;
    }

    @media (max-width: 576px) {
        .all-v {
            padding-left: 17px;
            padding-right: 17px;
        }

        .auth-form {
            display: block;
            width: 100%;
            max-width: 320px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
